import api from "../../../services/api";
import { OWNER_PORTFOLIO_ENDPOINT } from "../constants/ownerPortfolio";
import {
  InspectionCache,
  InspectionFile,
  OwnerPortfolioData,
  OwnerPortfolioQuery,
} from "../types/ownerPortfolio.types";
import { buildOwnerPortfolioParams } from "../utils/buildOwnerPortfolioParams";
import { normalizeInspectionCache } from "../utils/normalizeInspectionCache";
import { normalizeOwnerPortfolio } from "../utils/normalizeOwnerPortfolio";

function inspectionPath(kenloPropertyId: string): string {
  return `${OWNER_PORTFOLIO_ENDPOINT}/inspections/${encodeURIComponent(kenloPropertyId)}`;
}

export async function fetchOwnerPortfolio(
  query: OwnerPortfolioQuery
): Promise<OwnerPortfolioData> {
  const response = await api.get(OWNER_PORTFOLIO_ENDPOINT, {
    params: buildOwnerPortfolioParams(query),
  });

  return normalizeOwnerPortfolio(response.data?.data);
}

export async function fetchOwnerInspection(
  kenloPropertyId: string
): Promise<InspectionCache> {
  const response = await api.get(inspectionPath(kenloPropertyId));
  return normalizeInspectionCache(response.data?.data, kenloPropertyId);
}

export async function requestOwnerInspection(
  kenloPropertyId: string
): Promise<InspectionCache> {
  const response = await api.post(inspectionPath(kenloPropertyId));
  return normalizeInspectionCache(response.data?.data, kenloPropertyId);
}

export async function fetchOwnerInspectionFile(
  kenloPropertyId: string
): Promise<InspectionFile> {
  const response = await api.get(`${inspectionPath(kenloPropertyId)}/file`);
  const data = response.data?.data;
  const url = typeof data?.url === "string" ? data.url.trim() : "";

  if (!url) {
    throw new Error("Inspection file URL is missing");
  }

  return {
    url,
    expires_in_seconds:
      typeof data?.expires_in_seconds === "number" ? data.expires_in_seconds : null,
  };
}
